import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Paper, Tabs, Tab } from '@mui/material';

/**
 * Account Tabs component
 * Displays tabs for different account settings sections
 *
 * @param {Object} props - Component props
 * @param {number} props.activeTab - Currently active tab index
 * @param {Function} props.handleTabChange - Function to handle tab changes
 * @param {React.ReactNode} props.children - Tab content
 * @returns {JSX.Element} The AccountTabs component
 */
const AccountTabs = ({ activeTab, handleTabChange, children }) => {
  const { t } = useTranslation('user');

  return (
    <Paper sx={{ mt: 3 }}>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
        sx={{ borderBottom: 1, borderColor: 'divider' }}
      >
        <Tab label={t('account.tabs.profile')} />
        <Tab label={t('account.tabs.password')} />
        <Tab label={t('account.tabs.notifications')} />
        <Tab label={t('account.tabs.language')} />
      </Tabs>

      <Box sx={{ p: 3 }}>{children}</Box>
    </Paper>
  );
};

export default AccountTabs;
